import React, { useEffect } from 'react';
// import {Button} from 'react-bootstrap';
import { useTable, useGlobalFilter, useSortBy  } from "react-table";
import { FixedSizeList } from 'react-window';

import useWindowDimensions from './getwindows'



const VirtualTable = ({ columns, data, search, intl, pageSize }) => {
  // Use the state and functions returned from useTable to build your UI
  const {
    prepareRow,
    // page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    rows,

    // setPageSize,
    setGlobalFilter,
  } = useTable({
    columns,
    data,
    manualSortBy: true,
    disableSortBy: true,
    autoResetSortBy: false,
  }, useGlobalFilter, useSortBy);

  useEffect(() => {
    // console.log('debug: virtual-table: useEffect', search);
    setGlobalFilter(search);
  }, [search, setGlobalFilter]);

  // useEffect(() => {
  //   setPageSize(pageSize ? pageSize : 6);
  // }, [pageSize, setPageSize]);

  const RenderRow = React.useCallback(
    ({ index, style }) => {
      const row = rows[index]
      prepareRow(row)
      return (
        <div {...row.getRowProps({style})}>
          {row.cells.map(cell => {
            return <div {...cell.getCellProps()}>{cell.render('Cell')}</div>
          })}
        </div>
      )
    },
    [prepareRow, rows]
  )

  const {width, height} = useWindowDimensions();

  // console.log(height)

  let itemSize;

  switch (true) {
    case width > 1284 && width < 1378:
      itemSize = 120;
      break;
    default:
      itemSize = 103;
  }

  // Render the UI for your table
  return (
    <React.Fragment>
      <div className="events-container pre-container">
        {/* {rows.map((row, i) => {
          prepareRow(row)
          return (
            <div {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <div {...cell.getCellProps()}>{cell.render('Cell')}</div>
              })}
            </div>
          )
        })} */}
        
        {/* another way to write the above one */}
        <FixedSizeList
          height={height - 313 + 30}
          itemCount={rows.length}
          itemSize={itemSize}
          width={'100%'}
        >
          {RenderRow}
        </FixedSizeList>
      </div>
    </React.Fragment>
  )
}

export default VirtualTable;